import baseFields from "./cabinetFields.json";
import messages from "./cabinetMessages.json";
import { safeUrl, sanitizeHtml } from "./safeContent";
export const GROUP_LABELS = {
  cabinet: "Спільні повідомлення, знижки та запрошення",
  orders: "Замовлення",
  businessOrders: "Бізнес-замовлення",
  invoices: "Рахунки",
  roleForm: "Повідомлення анкет",
  libraryOffers: "Пропозиції бібліотекам",
  businessTiles: "Бізнес-плашки",
  settings: "Налаштування",
  profile: "Поля профілю",
  addresses: "Адреси доставки",
  chat: "Чат",
  chatBadge: "Кнопка чату",
  commercialNews: "Комерційні новини"
};
export const DOCUMENT_LABELS = {
  userCabinet: "Спільні описи",
  blockReader: "Клуб Майстрів",
  blockLibrarian: "Бібліотекар",
  blockMaister: "Майстер",
  blockBusiness: "Бізнес-партнер"
};
export const DOCUMENT_IDS = Object.keys(DOCUMENT_LABELS);
export const fieldsFor = id => [...(baseFields[id] || []).flatMap(field => field.path.startsWith("registration.byRole.") ? [{
  path: field.path.replace(".byRole.", ".useShared."),
  label: `${field.label}: використовувати загальний опис`,
  type: "boolean"
}, field] : [field]), ...(id === "userCabinet" ? Object.entries(messages).flatMap(([group, texts]) => Object.entries(texts).filter(([key]) => !(group === "cabinet" && ["text018", "label050", "label051", "label052", "label053", "label054"].includes(key))).map(([key, text]) => ({
  path: `messages.${group}.${key}`,
  label: text.length > 90 ? `${text.slice(0, 87)}...` : text,
  type: "textarea",
  group: GROUP_LABELS[group],
  defaultValue: text
}))) : [])];
export function getPath(value, path) {
  return path.split(".").reduce((obj, key) => obj?.[key], value);
}
export function setPath(value, path, next) {
  const [key, ...rest] = path.split(".");
  if (["__proto__", "prototype", "constructor"].includes(key)) throw new Error("Неприпустиме поле");
  return {
    ...value,
    [key]: rest.length ? setPath(value?.[key] || {}, rest.join("."), next) : next
  };
}
const userDefaults = {
  hero: {
    missionText: "Наша місія — допомогти батькам ростити дітей людьми, які вміють бути щасливими",
    goalText: "Наша мета — створювати якісні дитячі книги, від яких важко відірватися, та які збагачують."
  },
  registration: {
    prefix: "Ви зареєстровані як",
    descriptionHtml: `<p>${messages.cabinet.text018}</p>`
  },
  socialLinks: {
    facebookUrl: "https://www.facebook.com/chasmaistriv",
    email: "sales@chasmaistriv.com.ua",
    telegramUrl: "https://t.me/chas_maistriv",
    viberUrl: "https://invite.viber.com/?g2=AQBidB45Be8Vo057AydEGn81babrL0jatg7TIhXEIJeF4eMeFK1Qr4RQChEzk%2Fix"
  },
  businessTelegramUrl: "https://t.me/+EPPTExOea0oxYjVi",
  discount: {
    unsigned: {
      title: "Ваша знижка*",
      subtitle: "Для отримання знижки 5% підпишіться на наш телеграм канал",
      stepsTitle: "Для успішного отримання знижки вам потрібно зробити наступні кроки:",
      steps: [],
      getIdBotUrl: "https://t.me/getidsbot",
      channelUrl: "https://t.me/chas_maistriv"
    },
    signed: {
      noteTitle: "Ваша знижка*",
      note: "До знижки не додаються акції, розпродаж, предпродаж",
      inviteCta: "Запросити"
    }
  },
  elephants: {
    leadHtml: "Ви можете <br /> сплачувати слонами <br /> за наші книги",
    infoReader: "1 Слон = 1 Грн"
  }
};
export function resolveContent(id, raw = {}) {
  let result = {
    ...raw
  };
  fieldsFor(id).forEach(field => {
    let value = getPath(raw, field.path);
    if (value === undefined || value === null) {
      if (field.path.startsWith("registration.useShared.")) {
        const role = field.path.split(".").at(-1);
        value = raw.registration?.byRole?.[role] == null && !(role === "maister" && raw.registration?.byRole?.retailer != null);
      } else if (field.path.startsWith("registration.byRole.")) {
        value = field.path.endsWith("maister") ? raw.registration?.byRole?.retailer : undefined;
        value ??= raw.registration?.descriptionHtml ?? userDefaults.registration.descriptionHtml;
      } else value = field.defaultValue ?? (id === "userCabinet" ? getPath(userDefaults, field.path) : undefined) ?? (field.type === "boolean" ? true : field.type === "lines" ? [] : "");
    }
    result = setPath(result, field.path, value);
  });
  return result;
}
export function validateContent(id, model) {
  const errors = {};
  fieldsFor(id).forEach(field => {
    const value = getPath(model, field.path);
    if (field.type === "boolean") {
      if (typeof value !== "boolean") errors[field.path] = "Оберіть стан перемикача.";
    } else if (field.type === "lines") {
      if (!Array.isArray(value) || value.length > 30 || value.some(v => typeof v !== "string" || v.length > 2000)) errors[field.path] = "До 30 кроків, до 2000 символів кожен.";
    } else if (typeof value !== "string") errors[field.path] = "Очікується текст.";else if (value.length > (field.type === "html" ? 30000 : field.type === "textarea" ? 6000 : 2000)) errors[field.path] = "Текст перевищує дозволену довжину.";else if (["url", "email", "route"].includes(field.type) && value.trim() && !safeUrl(value, field.type)) errors[field.path] = field.type === "route" ? "Шлях має починатися з одного / без пробілів." : "Перевірте адресу та протокол посилання.";
  });
  if (new Blob([JSON.stringify(model)]).size > 350000) errors._document = "Контент перевищує 350 КБ.";
  return errors;
}
export function prepareContent(id, model) {
  const errors = validateContent(id, model);
  if (Object.keys(errors).length) throw Object.assign(new Error("Перевірте позначені поля."), {
    fields: errors
  });
  let next = {
    ...model
  };
  fieldsFor(id).forEach(field => {
    const value = getPath(model, field.path);
    if (field.type === "html") next = setPath(next, field.path, sanitizeHtml(value));
    if (["url", "email", "route"].includes(field.type)) next = setPath(next, field.path, safeUrl(value, field.type));
  });
  return next;
}
export function contentSignature(value) {
  const stable = v => {
    if (Array.isArray(v)) return v.map(stable);
    if (v && typeof v === "object") return Object.fromEntries(Object.keys(v).sort().map(k => [k, stable(v[k])]));
    return v;
  };
  return JSON.stringify(stable(value ?? null));
}
